module.exports = __webpack_public_path__ + "img/lead03.768b269b.png";